import React, { useEffect, useState } from "react";
import { Container, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, CircularProgress, Box } from "@mui/material";
import api from "../../services/api";

const AdminUsersStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.users.getUsersStats()
      .then(res => {
        setStats(res.data);
        setLoading(false);
      })
      .catch(err => setLoading(false));
  }, []);

  if (loading) return <Box sx={{ textAlign: "center", mt: 4 }}><CircularProgress /></Box>;
  if (!stats) return <Typography color="error">Could not load user stats</Typography>;

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Στατιστικά Χρηστών & Συνδρομών</Typography>
      <Typography>Σύνολο: {stats.total} | Με πληρωμή: {stats.paid} | Σε trial: {stats.trials} | Ληγμένες: {stats.expired}</Typography>
      <Paper sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Username</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Trial Ends</TableCell>
              <TableCell>Subscription Expires</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Roles</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stats.users.map((u) => (
              <TableRow key={u.email}>
                <TableCell>{u.username}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell>{u.trial_ends_at ? new Date(u.trial_ends_at).toLocaleString() : '-'}</TableCell>
                <TableCell>{u.subscription_expires_at ? new Date(u.subscription_expires_at).toLocaleString() : '-'}</TableCell>
                <TableCell>{u.subscription_plan || '-'}</TableCell>
                <TableCell>{u.roles.join(', ')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};
export default AdminUsersStats;
